/**
 * Dados mock para desenvolvimento local.
 * Ativados quando USE_MOCK = true (REACT_APP_USE_MOCK=true no .env.development).
 */

// ── Alarmes e Relatórios ──────────────────────────────────────────

export const mockUsinas = [
    { token: 'mock_token_001', nome: 'Usina São João', email: 'operacao@saojao.com.br', recebe_alarmes: true, recebe_relatorios: true },
    { token: 'mock_token_002', nome: 'Usina Iracema', email: '', recebe_alarmes: false, recebe_relatorios: false },
    { token: 'mock_token_003', nome: 'Usina Santa Cruz', email: 'alarmes@santacruz.com.br', recebe_alarmes: true, recebe_relatorios: false },
]

// ── Variáveis disponíveis para gráficos ──────────────────────────

export const mockVarList = {
    categorias: [
        {
            nome: 'Unidade Hidráulica',
            variaveis: [
                { campo: 'uh1_transmissor_temperatura_caixa', label: 'Temperatura do Óleo (°C)' },
                { campo: 'uh1_transmissor_umidade', label: 'Umidade do Óleo (%)' },
                { campo: 'uh1_transmissor_pressao_filtro_1', label: 'Pressão Filtro 1 (bar)' },
                { campo: 'uh1_resultado_teste_bomba_1', label: 'Autoteste Bomba 1 (psi)' },
                { campo: 'uh1_resultado_teste_bomba_2', label: 'Autoteste Bomba 2 (psi)' },
                { campo: 'uh1_status_uh', label: 'Status UH' },
            ]
        },
        {
            nome: 'Terno 1',
            variaveis: [
                { campo: 't1_transmissor_pressao_ld', label: 'Pressão LD (psi)' },
                { campo: 't1_transmissor_pressao_le', label: 'Pressão LE (psi)' },
                { campo: 't1_transmissor_deslocamento_ld', label: 'Deslocamento LD (mm)' },
                { campo: 't1_transmissor_deslocamento_le', label: 'Deslocamento LE (mm)' },
                { campo: 't1_status', label: 'Status Terno 1' },
            ]
        },
        {
            nome: 'Terno 2',
            variaveis: [
                { campo: 't2_transmissor_pressao_ld', label: 'Pressão LD (psi)' },
                { campo: 't2_transmissor_pressao_le', label: 'Pressão LE (psi)' },
                { campo: 't2_transmissor_deslocamento_ld', label: 'Deslocamento LD (mm)' },
                { campo: 't2_transmissor_deslocamento_le', label: 'Deslocamento LE (mm)' },
                { campo: 't2_status', label: 'Status Terno 2' },
            ]
        },
        {
            nome: 'Terno 3',
            variaveis: [
                { campo: 't3_transmissor_pressao_ld', label: 'Pressão LD (psi)' },
                { campo: 't3_transmissor_pressao_le', label: 'Pressão LE (psi)' },
                { campo: 't3_transmissor_deslocamento_ld', label: 'Deslocamento LD (mm)' },
                { campo: 't3_transmissor_deslocamento_le', label: 'Deslocamento LE (mm)' },
                { campo: 't3_status', label: 'Status Terno 3' },
            ]
        },
    ]
}

// ── Gráficos sugeridos (baseados em status crítico) ─────────────

export const mockSugestoes = {
    sugestoes: [
        {
            id: 'desnivelamento-t2',
            titulo: 'Deslocamento Terno 2 (LD/LE)',
            descricao: 'Terno 2 está com diferença de altura acima do limite — desnivelado.',
            severidade: 'critico' as const,
            grafico: 'ternos',
            onlyId: '2',
            campo: null,
        },
        {
            id: 'temp-oleo',
            titulo: 'Temperatura do Óleo',
            descricao: 'Temperatura do óleo em estado de atenção.',
            severidade: 'atencao' as const,
            grafico: 'temperatura-oleo',
            onlyId: null,
            campo: null,
        },
    ]
}

// ── Dados de gráfico (série temporal) ───────────────────────────

// Intervalo de 2h entre pontos (em vez de 5min) — com 60 pontos cobre ~5 dias, cruzando vários
// dias-calendário, pra dar pra ver a linha/label de troca de dia do gráfico em modo mock.
function generateTimeSeries(baseValue: number, variance: number, points: number, intervalMs = 2 * 60 * 60 * 1000) {
    const now = new Date()
    return Array.from({ length: points }, (_, i) => ({
        timestamp: new Date(now.getTime() - (points - i) * intervalMs).toISOString(),
        value: baseValue + (Math.random() - 0.5) * variance,
    }))
}

export const mockChartData = {
    'temperatura-oleo': generateTimeSeries(42, 10, 60),
    'umidade-oleo': generateTimeSeries(35, 8, 60),
    'pressao-filtro': generateTimeSeries(1.2, 0.4, 60),
    'variavel-generica': generateTimeSeries(100, 20, 60),
}

export const mockChartDataTernos = [1, 2, 3].map(t => ({
    terno_id: t,
    data: generateTimeSeries(2800 + t * 50, 200, 60).map(p => ({
        ...p,
        pressao_ld: p.value,
        pressao_le: p.value - 50 + Math.random() * 100,
        deslocamento_ld: 15 + Math.random() * 5,
        deslocamento_le: 14 + Math.random() * 5,
    }))
}))

// ── Dashboard ─────────────────────────────────────────────────────
// 3 usinas no seletor, para testar a troca manual e a troca automática.

export const mockDashboard = {
    moendas: [
        { token: 'mock_dash_001', nome: 'Usina São João' },
        { token: 'mock_dash_002', nome: 'Usina Iracema' },
        { token: 'mock_dash_003', nome: 'Usina Santa Cruz' },
    ],
    moendaAtual: {
        nome: 'Usina São João',
        ultimo_envio: Date.now() - 30_000,
        offline: false,
        ternos: [
            { terno_id: 1, nome_terno: 'Terno 1', manual: false, funcionando: true },
            { terno_id: 2, nome_terno: 'Terno 2', manual: false, funcionando: true },
            { terno_id: 3, nome_terno: 'Terno 3', manual: true, funcionando: true },
        ],
        unidadeHidraulica: {
            status: 20,
            manual: false,
            bomba: {
                transmissor_pressao_1: 142,
                transmissor_pressao_2: 138,
                transmissor_pressao_3: null as number | null,
                data: '',
                situacao: 0,
                autoteste_bomba_1: 145,
                autoteste_bomba_2: 160,
                autoteste_bomba_3: null as number | null,
                pressao_max: 250,
            },
            oleo: {
                temperatura: 58.4,
                trans_umidade: 38,
                trans_fil_suj_1: 1.7,
                trans_fil_suj_2: null as number | null,
                situacao: 0,
                alarme_conjunto_filtro_1: 1,
                alarme_conjunto_filtro_2: 1,
            },
            transmissores: [] as { terno_id: number, nome_terno: string }[],
            valvulas: [] as { terno_id: number, nome_terno: string }[],
        },
    },
    grafico: mockChartDataTernos,
}

// ── Auto Tuning ──────────────────────────────────────────────────

export const mockAutotuning = {
    status: 1, // 0=desativado, 1=ativo, 2=desativado pela equipe interna
    historico: [
        {
            id: 8,
            criado_em: new Date(Date.now() - 5 * 60 * 1000).toISOString(),
            equipamento: 'uh1',
            parametro: 'seletor_bomba',
            valor_anterior: '2',
            valor_novo: '4',
            taxa_calculada: null,
            motivo: 'Média de válvulas (84.2%) acima do limiar superior (80%) ou ternos críticos (6) acima do máximo (5)',
        },
        {
            id: 7,
            criado_em: new Date(Date.now() - 35 * 60 * 1000).toISOString(),
            equipamento: 't2',
            parametro: 'deltaz',
            valor_anterior: '4.00',
            valor_novo: '4.50',
            taxa_calculada: 1.45,
            motivo: 'Taxa de deslocamento (1.450 ac/min) acima do limite superior (1.2)',
        },
        {
            id: 6,
            criado_em: new Date(Date.now() - 35 * 60 * 1000).toISOString(),
            equipamento: 't1',
            parametro: 'tol_sup',
            valor_anterior: '1.0300',
            valor_novo: '1.0350',
            taxa_calculada: 1.38,
            motivo: 'Taxa de pressão (1.380 ac/min) acima do limite superior (1.2)',
        },
        {
            id: 5,
            criado_em: new Date(Date.now() - 35 * 60 * 1000).toISOString(),
            equipamento: 't1',
            parametro: 'tol_inf',
            valor_anterior: '0.9700',
            valor_novo: '0.9750',
            taxa_calculada: 1.38,
            motivo: '',
        },
        {
            id: 4,
            criado_em: new Date(Date.now() - 70 * 60 * 1000).toISOString(),
            equipamento: 't3',
            parametro: 'tol_sup',
            valor_anterior: '1.0350',
            valor_novo: '1.0300',
            taxa_calculada: 0.62,
            motivo: 'Taxa de pressão (0.620 ac/min) abaixo do limite inferior (0.8)',
        },
        {
            id: 3,
            criado_em: new Date(Date.now() - 70 * 60 * 1000).toISOString(),
            equipamento: 't3',
            parametro: 'tol_inf',
            valor_anterior: '0.9750',
            valor_novo: '0.9700',
            taxa_calculada: 0.62,
            motivo: '',
        },
        {
            id: 2,
            criado_em: new Date(Date.now() - 140 * 60 * 1000).toISOString(),
            equipamento: 'uh1',
            parametro: 'seletor_bomba',
            valor_anterior: '4',
            valor_novo: '2',
            taxa_calculada: null,
            motivo: 'Média de válvulas (31.7%) abaixo do limiar inferior (40%) e ternos críticos (1) abaixo do mínimo (2)',
        },
        {
            id: 1,
            criado_em: new Date(Date.now() - 200 * 60 * 1000).toISOString(),
            equipamento: 't2',
            parametro: 'deltaz',
            valor_anterior: '4.50',
            valor_novo: '4.00',
            taxa_calculada: 0.71,
            motivo: 'Taxa de deslocamento (0.710 ac/min) abaixo do limite inferior (0.8)',
        },
    ],
};

// ── Dados de correlação ──────────────────────────────────────────

export const mockCorrelacao = {
    pares: [
        { campo1: 'uh1_transmissor_temperatura_caixa', label1: 'Temperatura do Óleo', campo2: 'uh1_transmissor_umidade', label2: 'Umidade do Óleo', r: 0.82 },
        { campo1: 'uh1_transmissor_temperatura_caixa', label1: 'Temperatura do Óleo', campo2: 't1_transmissor_pressao_ld', label2: 'Pressão LD T1', r: -0.45 },
        { campo1: 'uh1_transmissor_umidade', label1: 'Umidade do Óleo', campo2: 't1_transmissor_pressao_ld', label2: 'Pressão LD T1', r: -0.31 },
        { campo1: 'uh1_transmissor_temperatura_caixa', label1: 'Temperatura do Óleo', campo2: 'uh1_transmissor_pressao_filtro_1', label2: 'Pressão Filtro 1', r: 0.67 },
        { campo1: 'uh1_transmissor_umidade', label1: 'Umidade do Óleo', campo2: 'uh1_transmissor_pressao_filtro_1', label2: 'Pressão Filtro 1', r: 0.54 },
        { campo1: 't1_transmissor_pressao_ld', label1: 'Pressão LD T1', campo2: 'uh1_transmissor_pressao_filtro_1', label2: 'Pressão Filtro 1', r: 0.12 },
    ],
    evento: [
        { campo: 'uh1_transmissor_temperatura_caixa', label: 'Temperatura do Óleo', r: 0.91 },
        { campo: 'uh1_transmissor_pressao_filtro_1', label: 'Pressão Filtro 1', r: 0.73 },
        { campo: 'uh1_transmissor_umidade', label: 'Umidade do Óleo', r: 0.62 },
        { campo: 't1_transmissor_pressao_ld', label: 'Pressão LD T1', r: -0.38 },
        { campo: 't2_transmissor_pressao_ld', label: 'Pressão LD T2', r: -0.27 },
    ]
}
